/* eslint-disable no-shadow */

/**
 * @return {boolean} the tts object
 */
export const tts = ({ tts }) => tts

/**
 * @returns {boolean} true if tts is enabled
 */
export const ttsEnabled = ({ ttsEnabled }) => ttsEnabled

export const imagesSelected = ({ imagesSelected }) => imagesSelected

export const globalSettingsDialogOpened = ({ globalSettingsDialogOpened }) => globalSettingsDialogOpened

export const imageSize = ({ imageSize }) => imageSize

export const ttsSpeed = ({ ttsSpeed }) => ttsSpeed

export const ttsLanguage = ({ ttsLanguage }) => ttsLanguage
